module.exports = __webpack_public_path__ + "static/media/footer-sprinx-logo.30ade9ae.webp";